import * as yup from 'yup';
import { PressLogos } from '../../components';
import { schema as pressQuoteSchema } from './press_quote';

export const component = PressLogos;

export const schema = yup.object({
  publications: yup.array(pressQuoteSchema).required(),
});
